export enum ZoneIdType {
  // UK
  LONDON = '79dff00a-b262-46c8-8d54-0aa6d4325d87',
  OUT_OPERATIVE_UK_AREA = '9e56cea8-1c4f-4412-833f-10fdd5d193b8',

  // France
  OUT_OPERATIVE_FRANCE_AREA = '65c2e085-f727-4d32-9a84-0ded9245b7cc',
  PARIS = '494afafc-9eb3-4f96-a923-0eaf0346d5fb',
  LYON = '0d5239b7-d847-4454-b6d0-3c8d97eddb28',

  // Chile
  CHILE = 'f8ec5b35-070e-4701-8b5e-786958c6d272',

  // Spain
  MADRID = '1ad0184f-e0cc-41d8-a1d1-1a2c29d1cc4f',
  SEVILLA = '53a74af1-481e-4ec3-8f7c-1e0b03cb6514',
  BARCELONA = '990fdc23-543d-4840-90f6-3757cea5790d',
  BILBAO = '59b397f7-5125-42b1-b74b-4aad7b271259',
  ALICANTE = '68e05f9e-0c8c-4007-ae21-668fbfb55bed',
  BALEARES = '031ab726-285e-4e53-8b9e-68b84e491fc2',
  ZARAGOZA = '2e3800b2-7486-4b9b-b143-7612563a6769',
  VALENCIA = 'aadcbbf1-d9ae-4885-84af-7e878ecc3688',
  OUT_OPERATIVE_SPAIN_AREA = '513de3d1-df7c-4bb8-b080-8d50d1220782',
  VIGO = 'fec39811-a493-4c76-b4a0-b44c839820d3',
  OVIEDO = 'e1cf25f7-6f92-4afe-a8f2-c29a3e02a8eb',
  SANTANDER = 'afc9a057-063a-4653-9f73-ec6b8adba201',
  MALAGA = 'fe830982-352a-4300-9ade-f1a80846e103'
}
